module.exports = __webpack_public_path__ + "img/Tier.02fdb908.svg";